<div class="shared-ui-text-input shared-ui-control" *ngIf="control">
  <label for="txtBox" class="fwform-label">{{ label }}</label>
  <input type="text" name="txtBox" [formControl]="control" [readonly]="isReadOnly" />
  <ngb-alert *ngIf="control.errors" [dismissible]="false">
    <div class="shared-ui-text-input-val-error" *ngFor="let error of control.errors | validationErrorKeys">{{messages[error]}}</div>
  </ngb-alert>
</div>
